import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'wsm-common-data';
import { getImagesToDisplay } from '../helpers/imageSelection';
import ImageSlot from './ImageSlot';

const buildAltText = (vehicle) => {
	const { year = '', make = '', model = '' } = vehicle || {};
	const modelValue =
		typeof model === 'object' ? Object.values(model)[0] : model;
	const vehicleName = [year, make, modelValue].filter(Boolean).join(' ');

	return vehicleName || '';
};

const VehicleImages = ({ images, vehicle }) => {
	const { beginImageDisplayAt } = usePrefs();
	const slots = getImagesToDisplay(images, beginImageDisplayAt);

	return (
		<div>
			<div className="col-12 col-md-8 p-0">
				<ImageSlot
					image={slots[0]}
					index={0}
					altText={buildAltText(vehicle, 0)}
					className="pb-3 pb-lg-0 pr-lg-3"
				/>
			</div>
			<div className="col-12 col-md-4 d-flex p-0 flex-lg-column">
				<div className="flex-grow-1 flex-basis-0">
					<ImageSlot
						image={slots[1]}
						index={1}
						altText={buildAltText(vehicle, 1)}
						className="pr-2 pr-lg-0 pb-lg-2"
					/>
				</div>
				<div className="flex-grow-1 flex-basis-0">
					<ImageSlot
						image={slots[2]}
						index={2}
						altText={buildAltText(vehicle, 2)}
						className="pl-2 pl-lg-0 pt-lg-2"
					/>
				</div>
			</div>
		</div>
	);
};

VehicleImages.propTypes = {
	images: PropTypes.arrayOf(PropTypes.shape({ uri: PropTypes.string })),
	vehicle: PropTypes.shape({})
};

VehicleImages.defaultProps = {
	images: [],
	vehicle: {}
};

export default VehicleImages;
